import { authClient } from "@/clients/authClient";
export function useIsAdmin() {
  const {
    data: session
  } = authClient.useSession();
  return session?.user?.role === "admin";
}